/**
 * Serviço de Notificações Frontend
 * Gerencia notificações in-app do sistema
 */

import { API_CONFIG } from './staticDataConfig';
import { authService } from './authService';

export interface Notificacao {
  id: number;
  tipo: string;
  titulo: string;
  mensagem: string;
  status: string;
  lido_em: string | null;
  criado_em: string;
  prioridade: string;
  referente_tipo?: string;
  referente_id?: string;
  meta_json?: any;
}

export interface NotificacaoPreferencias {
  notificacoes_habilitadas: boolean;
  som_habilitado: boolean;
  alerta_antes_consulta: number;
  alerta_pagamento_apos_consulta: number;
  alerta_prontuario_pendente: number;
  alerta_plano_vencimento: number;
  tipo_lembrete_consulta: boolean;
  tipo_pagamento_aprovado: boolean;
  tipo_pagamento_pendente: boolean;
  tipo_prontuario_pendente: boolean;
  tipo_plano_vencendo: boolean;
}

class NotificationsService {
  private baseURL: string;

  constructor() {
    this.baseURL = `${API_CONFIG.BASE_URL}/notificacoes`;
  }

  async listar(filtros?: {
    status?: string;
    tipo?: string;
    page?: number;
    pageSize?: number;
  }): Promise<{ items: Notificacao[]; total: number; naoLidas: number }> {
    const token = authService.getToken();
    const params = new URLSearchParams(filtros as any);
    
    const response = await fetch(`${this.baseURL}?${params}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const result = await response.json();
    if (!result.sucesso) throw new Error(result.mensagem);
    return result.dados;
  }

  async contarNaoLidas(): Promise<number> {
    const token = authService.getToken();
    
    const response = await fetch(`${this.baseURL}/nao-lidas/count`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const result = await response.json();
    if (!result.sucesso) throw new Error(result.mensagem);
    return result.dados.total;
  }

  async marcarComoLidas(ids: number[]): Promise<void> {
    const token = authService.getToken();
    
    await fetch(`${this.baseURL}/mark-read`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ids })
    });
  }

  async buscarPreferencias(): Promise<NotificacaoPreferencias> {
    const token = authService.getToken();
    
    const response = await fetch(`${this.baseURL}/preferencias`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const result = await response.json();
    if (!result.sucesso) throw new Error(result.mensagem);
    return result.dados;
  }

  async atualizarPreferencias(preferencias: Partial<NotificacaoPreferencias>): Promise<void> {
    const token = authService.getToken();
    
    await fetch(`${this.baseURL}/preferencias`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(preferencias)
    });
  }
}

export const notificationsService = new NotificationsService();
